/* TinyTunes theme JS — no framework, no dependencies.
   Everything below mutates the cart through Shopify's Ajax API and then
   re-renders from the server response. Nothing is counted client-side. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------
     Cart — mutate, then re-render from Shopify's returned sections
     --------------------------------------------------------------- */
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function replaceSections(data) {
    if (!data || !data.sections) return;
    var parser = new DOMParser();

    if (data.sections['cart-drawer']) {
      var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#drawer');
      var live = $('#drawer');
      if (fresh && live) {
        var wasOpen = live.classList.contains('is-open');
        live.innerHTML = fresh.innerHTML;
        if (wasOpen) live.classList.add('is-open');
      }
    }
    if (data.sections['cart-icon-bubble']) {
      var bDoc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      var freshCount = bDoc.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach(function (el) {
        if (!freshCount) return;
        el.textContent = freshCount.textContent;
        el.hidden = freshCount.hidden;
      });
    }
    /* Fix C: loadCrossSell removed here — now only called when drawer opens */
  }

  /* ---------------------------------------------------------------
     PDP stock message helper
     --------------------------------------------------------------- */
  function showPdpStockMsg(text) {
    var msg = document.getElementById('pdp-stock-msg');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
  }
  function clearPdpStockMsg() {
    var msg = document.getElementById('pdp-stock-msg');
    if (!msg) return;
    msg.hidden = true;
    msg.textContent = '';
  }

  /* ---------------------------------------------------------------
     Cart drawer line-cap message helper
     --------------------------------------------------------------- */
  function showCartCapMsg(lineEl, text) {
    if (!lineEl) return;
    var existing = lineEl.querySelector('[data-cart-cap-msg]');
    if (existing) { existing.textContent = text; return; }
    var note = document.createElement('p');
    note.setAttribute('data-cart-cap-msg', '');
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');
    note.style.cssText = 'margin:4px 0 0;font-size:0.8rem;color:var(--muted,#888);';
    note.textContent = text;
    lineEl.appendChild(note);
    setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 5000);
  }

  function cartRequest(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, quantity, button) {
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding...'; }
    return cartRequest(window.TT.routes.cart_add, { items: [{ id: Number(variantId), quantity: quantity || 1 }] })
      .then(function (data) {
        if (button) {
          button.disabled = false;
          button.textContent = data.status ? button.dataset.label : 'Added';
          if (!data.status) setTimeout(function () { button.textContent = button.dataset.label; clearPdpStockMsg(); }, 1400);
        }
        if (data.status) {
          var qty = null;
          if (data.errors && typeof data.errors === 'object') {
            var errVal = data.errors[Object.keys(data.errors)[0]];
            if (Array.isArray(errVal) && errVal.length) {
              var match = String(errVal[0]).match(/(\d+)/);
              if (match) qty = parseInt(match[1], 10);
            }
          }
          var errMsg = (qty !== null && qty >= 0)
            ? 'Sorry, only ' + qty + ' available.'
            : 'Sorry, that quantity is no longer available.';
          showPdpStockMsg(errMsg);
          return;
        }
        clearPdpStockMsg();
        replaceSections(data);
        openDrawer();
      })
      .catch(function (e) {
        console.error(e);
        if (button) { button.disabled = false; button.textContent = button.dataset.label; }
      });
  }

  function changeLine(line, requestedQty) {
    var requested = Number(requestedQty);
    return cartRequest(window.TT.routes.cart_change, { line: Number(line), quantity: requested })
      .then(function (data) {
        replaceSections(data);
        if (requested > 0 && data && data.sections && data.sections['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
          var lineItems = doc.querySelectorAll('[data-line-item]');
          var idx = Number(line) - 1;
          var freshItem = lineItems[idx];
          if (freshItem) {
            var qtySpan = freshItem.querySelector('.qty span');
            if (qtySpan) {
              var actual = parseInt(qtySpan.textContent, 10);
              if (!isNaN(actual) && actual < requested) {
                var liveItems = document.querySelectorAll('[data-line-item]');
                showCartCapMsg(liveItems[idx], "Only " + actual + " available, so we've adjusted the quantity.");
              }
            }
          }
        }
      });
  }

  /* Complementary products from the Search & Discovery app, with a
     related-products fallback so the slot is never empty. */
  function loadCrossSell() {
    var host = $('[data-cross-sell]');
    if (!host) return;
    var id = host.dataset.productId;
    if (!id) return;

    function fetchIntent(intent) {
      var url = window.TT.routes.recommendations +
        '?section_id=cart-cross-sell&limit=10&product_id=' + id + '&intent=' + intent;
      return fetch(url).then(function (r) { return r.text(); });
    }

    fetchIntent('complementary')
      .then(function (html) {
        if (html && html.replace(/\s/g, '').length > 40) return html;
        return fetchIntent('related');
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.xsell__row');
        host.innerHTML = inner ? doc.body.innerHTML : '';
        var max = parseInt(host.dataset.limit, 10) || 3;
        var row = host.querySelector('.xsell__row');
        if (row) while (row.children.length > max) row.removeChild(row.lastElementChild);
      })
      .catch(function () { host.innerHTML = ''; });
  }

  /* ---------------------------------------------------------------
     Drawer + modal: open/close, overlay, focus handling
     --------------------------------------------------------------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var lastFocus = null;

  function openDrawer() {
    lastFocus = document.activeElement;
    var d = $('#drawer'); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    $('#overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-cart-close]'); if (close) close.focus();
    loadCrossSell(); /* Fix C: cross-sell loads when drawer opens */
  }
  function closeDrawer() {
    var d = $('#drawer'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    $('#overlay').classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function closeModal() {
    var m = $('#modal'); if (!m) return;
    m.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var box = $('#drawer') && $('#drawer').classList.contains('is-open') ? $('#drawer')
            : $('#modal') && $('#modal').classList.contains('is-open') ? $('#modal') : null;
    if (!box) return;
    var items = $$(FOCUSABLE, box).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------------------------------------------------------
     Predictive search
     --------------------------------------------------------------- */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    var panel = $('#search');
    var toggle = $('#search-toggle');
    if (!input || !results) return;

    var timer = null;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = window.TT.routes.predictive_search +
          '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product&resources[limit]=8';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            results.innerHTML = doc.body.innerHTML;
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);
    });

    function toggleSearch() {
      var open = panel.classList.toggle('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      if (open) input.focus();
      return open;
    }
    if (toggle) toggle.addEventListener('click', toggleSearch);
    $$('[data-mobile-search]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!panel.classList.contains('is-open')) toggleSearch();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  /* ---------------------------------------------------------------
     Collection filter tabs (client-side, within what is rendered)
     --------------------------------------------------------------- */
  function initTabs() {
    $$('[data-section-type="featured-products"]').forEach(function (section) {
      var tabs = $$('.tab', section);
      if (!tabs.length) return;
      var cards = $$('[data-product-card]', section);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var f = tab.dataset.filter;
          tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
          cards.forEach(function (c) {
            var list = ' ' + (c.dataset.collections || '') + ' ';
            c.hidden = !(f === 'all' || list.indexOf(' ' + f + ' ') > -1);
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Accordions (product page)
     --------------------------------------------------------------- */
  function initAccordions() {
    $$('[data-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------------------------------------------------------------
     Boot
     --------------------------------------------------------------- */
  function init() {
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-quick-add]');
      if (add) { e.preventDefault(); addToCart(add.dataset.variantId, 1, add); return; }

      var qty = e.target.closest('[data-qty-change]');
      if (qty) {
        e.preventDefault();
        var requestedQty = Number(qty.dataset.quantity);
        var cartMax = parseInt(qty.dataset.max, 10);
        if (!isNaN(cartMax) && requestedQty > cartMax) {
          var lineItem = qty.closest('[data-line-item]');
          showCartCapMsg(lineItem, 'Sorry, only ' + cartMax + ' are currently available.');
          return;
        }
        changeLine(qty.dataset.line, qty.dataset.quantity);
        return;
      }

      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      if (e.target.id === 'overlay') { closeDrawer(); return; }
      if (e.target.closest('#modal-close') || e.target.id === 'modal') { closeModal(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
        closeModal();
        var sp = $('#search');
        if (sp && sp.classList.contains('is-open')) toggleSearch();
        var mm = $('#mobilemenu');
        if (mm && mm.classList.contains('is-open')) {
          mm.classList.remove('is-open');
          var mt = $('#menu-toggle');
          if (mt) mt.setAttribute('aria-expanded', 'false');
        }
      }
      trapFocus(e);
    });

    var menu = $('#menu-toggle');
    if (menu) menu.addEventListener('click', function () {
      var open = $('#mobilemenu').classList.toggle('is-open');
      menu.setAttribute('aria-expanded', String(open));
    });

    initSearch();
    initTabs();
    initAccordions();

    var pdpForm = document.getElementById('product-form');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = pdpForm.querySelector('[name="id"]').value;
        var qty = parseInt((pdpForm.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        var btn = pdpForm.querySelector('[type="submit"]');
        addToCart(id, qty, btn);
      });

      /* Clear stock message when customer manually edits quantity input */
      var qtyInput = document.getElementById('pdp-qty');
      if (qtyInput) {
        qtyInput.addEventListener('input', function () { clearPdpStockMsg(); });
      }
    }

    /* Fix C: loadCrossSell only called from openDrawer(), not here */

    /* One gentle reveal per section, honouring reduced motion. */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      $$('.section').forEach(function (s) { s.classList.add('reveal'); io.observe(s); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.TTCart = { add: addToCart, open: openDrawer, close: closeDrawer };
})();


(function () {
  if (window.ttPdpGalleryHandlerInstalled) return;
  window.ttPdpGalleryHandlerInstalled = true;

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var thumbnail = event.target.closest('[data-pdp-thumb]');
    if (!thumbnail) return;

    var main = document.querySelector('[data-pdp-main]');
    if (!main) return;

    var mediaId = thumbnail.dataset.mediaId;
    var template = document.querySelector(
      '[data-pdp-media-template="' + mediaId + '"]'
    );

    if (!template) return;

    // Stop any currently playing video before switching media.
    main.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });

    // Replace the main gallery content with the selected image or video.
    main.innerHTML = template.innerHTML;

    // Update the selected thumbnail border.
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (button) {
      button.setAttribute(
        'aria-current',
        button === thumbnail ? 'true' : 'false'
      );
    });
  });
})();

